import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { ViewportScroller } from '@angular/common';
import { IcdServiceV1 } from '../../../../../shared/services/icdv1.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EventManager } from '../../../../../shared/services/broadcast.service';
import { SearchService } from '../../../../../shared/services/search.search';
import { IcdService, BASE } from 'src/shared/services/icd.service';
import { ToastrService } from 'ngx-toastr';

interface ChapterNode {
    name: string;
    model: string;
    id: string;
    children?: ChapterNode[];
    level: number;
    isLeaf: boolean;
    code: string;
    span: any;
}

@Component({
    selector: 'app-dual-version9-icd',
    templateUrl: './dual-version9-icd.component.html',
    styleUrls: ['./dual-version9-icd.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DualVersion9IcdComponent implements OnInit {
    chapter: any[] = [];
    infoModel: any;
    htmlRoot:any;
    dataSource = new MatTreeNestedDataSource<ChapterNode>();
    treeControl = new NestedTreeControl<ChapterNode>((node) => node.children);
    loaded: Set<string> = new Set<string>();
    isActive: string | null = '';
    language: any;
    userCommentList: any[] = [];
    showingComments = false;
    userCaptcha: string = '';
    errorMessage: string | undefined;
    contentMessage: string | undefined;
    nameMessage: string | undefined;
    emailMessage: string | undefined;
    phoneMessage: string | undefined;
    subjectMessage: string | undefined;
    public captchaImageUrl: string | undefined;
    isSearching: boolean = false;

    constructor(
        public icdService: IcdService,
        private toastService: ToastrService,
        private viewportScroller: ViewportScroller,
        private router: Router,
        private scroller: ViewportScroller,
        private route: ActivatedRoute,
        private eventManager: EventManager,
        public IcdServiceV1: IcdServiceV1,
        private _changeDetectorRef: ChangeDetectorRef,
        private searchService: SearchService
    ) {
        this.dataSource.data = [];
        this.eventManager.subscribe('changeLanguage', (lang: any) => {
            this.language = lang.content;
            this.getChapter();
        });
    }

    hasChild = (_: number, node: ChapterNode) => !node.isLeaf;

    ngOnInit(): void {
        this.language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'vi';
        this.getChapter();
        this.isActive = this.route.snapshot.queryParamMap.get('id');
        this.getListFeedback();
    }

    getChapter() {
        this.IcdServiceV1.getChapter_ICD9("dual").subscribe((res) => {
            this.chapter = res.data.map((value: any) => this.convertChapter(value));
            this.dataSource.data = this.chapter;
            this.infoModel = res.html;
            this.treeControl.dataNodes = this.chapter;
        });
    }

    getListFeedback() {
        this.icdService.getListFeedback().subscribe((res) => {
            this.userCommentList = res.data;
        });
    }

    toggleForm() {
        this.showingComments = !this.showingComments;
    }

    submitForm() {
        const feedbackData = this.getFeedbackData();

        this.icdService.submitFeedback(feedbackData).subscribe(
            (res: any) => {
                if (res.status === 'success')
                    this.toastService.success(`${res?.message}`, 'Thành công');
                else this.toastService.error(`${res?.message}`, 'Thất bại');
                if (res.captcha_image && this.captchaImageUrl !== res.captcha_image) {
                    const newCaptchaImageUrl = BASE + res.captcha_image;
                    this.updateCaptchaImage(newCaptchaImageUrl);
                    this.userCaptcha = '';
                } else {
                    this.handleSuccess(res);
                }
            },
            (error: any) => {
                this.handleError(error);
            }
        );
    }

    private getFeedbackData() {
        const name = (document.getElementById('name') as HTMLInputElement).value;
        const number = (document.getElementById('number') as HTMLInputElement).value;
        const email = (document.getElementById('email') as HTMLInputElement).value;
        const title = (document.getElementById('title') as HTMLInputElement).value;
        const feedback = (document.getElementById('feedback') as HTMLTextAreaElement).value;

        return {
            app: 'ICD9',
            name: name,
            phone: number,
            email: email,
            subject: title,
            content: feedback,
            captcha: this.userCaptcha,
        };
    }

    private updateCaptchaImage(newCaptchaImageUrl: string) {
        const timestamp = new Date().getTime();
        this.captchaImageUrl = newCaptchaImageUrl + `?timestamp=${timestamp}`;
    }

    private handleSuccess(res: any) {
        this.captchaImageUrl = undefined;
        this.getListFeedback();
        if (res.message) {
            this.showingComments = true;
        }
    }

    private handleError(error: any) {
        this.errorMessage = error.error?.message;
        // this.contentMessage = error.error.data?.content;
        this.nameMessage = error.error.data?.name;
        this.emailMessage = error.error.data?.email;
        this.phoneMessage = error.error.data?.phone;
        this.subjectMessage = error.error.data?.subject;

        if (error.error.data?.captcha_image) {
            const newCaptchaImageUrl = BASE + error.error.data.captcha_image;
            this.updateCaptchaImage(newCaptchaImageUrl);
        }

        this.userCaptcha = '';
    }

    convertChapter(input: any): ChapterNode {
        return {
            id: input.data.id,
            model: input.model,
            code: input.data.code,
            name: input.data.name,
            level: 0,
            isLeaf: input.is_leaf,
            children: input.children?.map((child: any) => this.convertChapter(child)),
            span: input.data.id,
        };
    }

    getDetailModel(item: any) {
        this.isSearching = true;
        this.htmlRoot=""
        this.IcdServiceV1.getDetailModel_ICD9(item?.model, item?.id, this.language).subscribe(
            (res) => {
                this.isSearching = false;
                this.infoModel = res.data.data;
            },
            (err) => {
                this.isSearching = false;
                this.toastService.error(`${err?.error.error}`, 'Thất bại');

            }
        );
    }

    getChildrenOfModel(item: ChapterNode) {
        if (this.loaded.has(item.id)) {
            return;
        }
        this.loaded.add(item.id);
        this.IcdServiceV1.getChildrenOfModel_ICD9(item?.model, item?.id, this.language).subscribe(
            (res) => {
                const children = res.data.map((value: any) => this.convertChapter(value));
                item.children = children;
                this.dataSource.data = [];
                this.dataSource.data = this.chapter;
                setTimeout(() => {
                    this.treeControl.expand(item);
                });
            }
        );
    }

    getChildrenOfTree(item: ChapterNode) {
        this.getChildrenOfModel(item);
        this.refreshTree();
    }

    goToDetail(item: ChapterNode) {
        this.isActive = item.id;
        this.getDetailModel(item);
    }

    receiveMessage($event: any) {
        this.infoModel = $event.data;
        this.isActive = $event.data.id;
        this.getListTreeOfSearch($event);
        this.handleScrollTree($event.data.id);
    }

    openItem(node: ChapterNode): void {
        if (node.children) this.treeControl.expand(node);
        node.children?.forEach((item) => this.openItem(item));
    }

    refreshTree() {
        let _data = this.dataSource.data;
        this.dataSource.data = [];
        this.dataSource.data = _data;
    }

    getListTreeOfSearch(item: any) {
        this.searchService
            .getListTreeOfSearch_ICD9(item.model, item.id, 'dual')
            .subscribe((res) => {
                const find = res.children.find((el: any) => el.children?.length > 0);
                const findnode = this.treeControl.dataNodes.find((dtn) => dtn.id === find.id);
                const children: ChapterNode[] = find.children.map((child: any) =>
                    this.convertChapter(child)
                );
                if (findnode) {
                    findnode.children = children;
                    this.dataSource.data = [];
                    this.dataSource.data = this.chapter;
                    this.openItem(findnode);
                }
            });
    }

    goToOpenTree(event: any) {
        event.preventDefault();
        let item = {
            model: '',
            id: '',
        };
        let href = '';
        let target = event.target || event.srcElement;
        while (target) {
            if (target instanceof HTMLAnchorElement) {
                href = target.getAttribute('href')!; //non-null assertion
                break;
            }
            target = target.parentNode;
        }
        item.id = href.split('/')[1];
        item.model = href.split('/')[0];

        if (item && item.id && item.model) {
            this.isActive = item.id;
            this.getListTreeOfSearch(item);
            this.getDetailModel(item);
            this.handleScrollTree(item.id);
        }
    }

    handleScrollTree(id: any) {
        setTimeout(() => {
            this.router.navigate([], { fragment: id }).then((res) => {
                const element = document.getElementById(id);
                if (element != undefined) element.scrollIntoView({ behavior: 'smooth' });
            });
        }, 1000);
    }
}
